import { localStorageManager } from '@mopla/utils';

export const personalDetailsManager =
	localStorageManager<'completed'>('personalDetails');
